module.exports = __webpack_public_path__ + "img/10.dd4dd87f.jpg";